import React, { useContext } from 'react';
import { injectIntl } from '@edx/frontend-platform/i18n';
import { TimerContext } from './TimerProvider';

/**
 * Display timer textual value. Display hide/show button.
 */
const FiveMinuteCountDownTimer = injectIntl((props) => {
  const timer = useContext(TimerContext);

  return (
    <span
      className="five-minute-count-down-timer"
    >
      {timer.getFiveMinuteTimerString()}
    </span>
  );
});

export default FiveMinuteCountDownTimer;
